/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Viewer_HintInputs */



/**
* | output |
* | --- |
* | "Reads analytics, levelling and team settings. Changes nothing." |
*
* @param {Preset_Viewer_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const preset_viewer_hint = /** @type {((inputs?: Preset_Viewer_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Viewer_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видит аналитику, уровни и настройки команды. Ничего не меняет.")
	return /** @type {LocalizedString} */ ("Reads analytics, levelling and team settings. Changes nothing.")
});